import React, { useState } from 'react';

const CompanyLayer = () => {
    const [formData, setFormData] = useState({
        supportEmail: '',
        supportPhone: '',
        facebookLink: '',
        linkedinLink: '',
        instagramLink: '',
        twitterLink: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Replace with your actual API endpoint
        const apiUrl = '/api/save-social-links';

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                console.log('Social links saved successfully!');
                // Optionally, show a success message to the user
            } else {
                console.error('Failed to save social links.');
                // Optionally, show an error message to the user
            }
        } catch (error) {
            console.error('There was an error saving the social links:', error);
            // Optionally, show an error message to the user
        }
    };

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="supportEmail"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Support Email <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="email"
                                    className="form-control radius-8"
                                    id="supportEmail"
                                    name="supportEmail"
                                    placeholder="Enter support email"
                                    value={formData.supportEmail}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="supportPhone"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Support Phone
                                </label>
                                <input
                                    type="tel"
                                    className="form-control radius-8"
                                    id="supportPhone"
                                    name="supportPhone"
                                    placeholder="Enter support phone number"
                                    value={formData.supportPhone}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="facebookLink"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Facebook Link
                                </label>
                                <input
                                    type="url"
                                    className="form-control radius-8"
                                    id="facebookLink"
                                    name="facebookLink"
                                    placeholder="Enter Facebook link"
                                    value={formData.facebookLink}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="linkedinLink"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    LinkedIn Link
                                </label>
                                <input
                                    type="url"
                                    className="form-control radius-8"
                                    id="linkedinLink"
                                    name="linkedinLink"
                                    placeholder="Enter LinkedIn link"
                                    value={formData.linkedinLink}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="instagramLink"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Instagram Link
                                </label>
                                <input
                                    type="url"
                                    className="form-control radius-8"
                                    id="instagramLink"
                                    name="instagramLink"
                                    placeholder="Enter Instagram link"
                                    value={formData.instagramLink}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="twitterLink"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Twitter Link
                                </label>
                                <input
                                    type="url"
                                    className="form-control radius-8"
                                    id="twitterLink"
                                    name="twitterLink"
                                    placeholder="Enter Twitter link"
                                    value={formData.twitterLink}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                            <button
                                type="reset"
                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                                onClick={() => setFormData({
                                    supportEmail: '',
                                    supportPhone: '',
                                    facebookLink: '',
                                    linkedinLink: '',
                                    instagramLink: '',
                                    twitterLink: '',
                                })}
                            >
                                Reset
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                            >
                                Save Change
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CompanyLayer;